<!--
 * @Author: guoyu
 * @Date: 2020-09-11 16:32:44
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-04 16:20:23
 * @Description: 技能描述
-->
<template>
  <div class="desc-container">
    <div class="desc-title">{{$t('upgrade_page_views_master_components_skill_info_desc_info_272')}}</div>
    <fps-voice
      v-if="skillInfo.voiceUrl"
      class="skill-voice"
      :src="skillInfo.voiceUrl"
      :color="'#222C43'"
      :control="false"
    />
    <LineControl
      class="skill-desc"
      v-if="skillInfo.description && isShow"
      :rows="8"
    >
      <el-input
        v-model="skillInfo.description"
        type="textarea"
        class="wrap-text"
        resize="none"
        autosize
        disabled
      />
    </LineControl>
    <div class="skill-level" v-if="skillInfo.platform">
      <span class="level-name">{{$t('upgrade_page_views_master_components_skill_info_desc_info_273')}}</span
      ><span>{{ skillInfo.platform.replace(/;/g, '/') }}</span>
    </div>
    <div class="skill-level" v-if="skillInfo.gameLevelString">
      <span class="level-name">{{$t('upgrade_page_views_player_list_index_178')}}</span
      ><span>{{ skillInfo.gameLevelString }}</span>
    </div>
    <template v-if="skillInfo.gamePropertyMap">
      <div
        v-for="(v, a) in skillInfo.gamePropertyMap"
        :key="`skill-attr${a}`"
        class="skill-attr"
      >
        <div class="skill-attr-name">{{ v.propertyName }}</div>
        <div class="skill-attr-value">{{ v.propertyValueList.join(' ') }}</div>
      </div>
    </template>
    <SwiperCollapse class="skill-image-sp" :options="imageList">
      <template v-slot="{ item }">
        <div class="skill-image" :style="{ backgroundImage: `url(${item})` }">
          <el-image :src="item" :preview-src-list="imageList" />
        </div>
      </template>
    </SwiperCollapse>
    <div class="score-box">
      <div v-if="skillInfo.serviceCount > 5">
        <div>{{ skillInfo.serviceCount || 0 }}</div>
        <div class="cn">{{$t('upgrade_page_views_master_components_skill_info_desc_info_274')}}</div>
      </div>
      <div v-if="skillInfo.serviceCount && skillInfo.serviceCount > 4">
        <div>{{ Math.round((skillInfo.repurchaseRate || 0) * 100) + '%' }}</div>
        <div class="cn">{{$t('upgrade_page_views_master_components_skill_info_desc_info_275')}}</div>
      </div>
      <div>
        <div>{{ Math.floor(skillInfo.averageRepurchaseRate || 0) > 100 ? '100+': Math.floor(skillInfo.averageRepurchaseRate || 0) }}</div>
        <div class="cn">{{$t('upgrade_page_views_master_components_skill_info_desc_info_276')}}</div>
      </div>
      <div v-if="skillInfo.replyRate != undefined">
        <div>{{ Math.round(skillInfo.replyRate * 100) + '%' }}</div>
        <div class="cn">{{$t('upgrade_page_views_master_components_skill_info_desc_info_277')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperCollapse from '@/components/common/swiper/swiper-collapse';
import LineControl from '@/components/common/text/line-control';
export default {
  components: {
    SwiperCollapse,
    LineControl
  },
  props: {
    skillInfo: {
      type: Object,
      default: nullObj
    },
    sex: {
      type: String,
      default: 'Female'
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isPlaying: false
    };
  },
  computed: {
    imageList() {
      return JSON.parse(this.skillInfo.screenshotImageUrlList || null) || [];
    },
    playerSex() {
      let s = this.sex || '';
      return s.toLocaleLowerCase();
    },
    isPc() {
      return window.innerWidth > 600;
    }
  },
  methods: {}
};
function nullObj() {
  return {};
}
</script>

<style lang="scss" scoped>
.skill-voice {
  width: 100px;
  margin-top: 12px;
}
.desc-container {
  padding: 24px 16px 24px;
  font-size: 14px;
  line-height: 20px;
  color: #636d86;
}
.desc-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #8c94aa;
}
.skill-image-sp {
  margin-top: 24px;
  margin-bottom: 24px;
  /deep/.el-icon-circle-close {
    color: #ffffff !important;
  }
  /deep/ .left-arrow {
    justify-content: flex-start;
    width: 100px;
    background: linear-gradient(
      270.24deg,
      rgba(255, 255, 255, 0) 0.17%,
      rgba(255, 255, 255, 0.79) 86.38%
    );
  }
  /deep/ .right-arrow {
    justify-content: flex-end;
    width: 100px;
    background: linear-gradient(
      270deg,
      #ffffff 13.01%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  /deep/ .arrow-icon {
    font-weight: 700;
    font-size: 15px;
    background: #ffffff;
    color: #bababa;
  }
  /deep/ .left-icon {
    margin-left: 18px;
  }
  /deep/ .right-icon {
    margin-right: 18px;
  }
}
.skill-image {
  height: 280px;
  max-width: 498px;
  overflow: hidden;
  margin-right: 16px;
  border-radius: 4px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /deep/ .el-image {
    display: block;
    height: 100%;
  }
  /deep/ .el-image__preview {
    width: auto;
    height: 100%;
    min-width: 280px;
    opacity: 0;
  }
}
.skill-desc {
  margin-bottom: 16px;
  font-size: 15px;
  line-height: 22px;
  color: #222c43;
  /deep/ .handle-button {
    text-align: right;
  }
}
.wrap-text {
  height: 100%;
  /deep/ .el-textarea__inner {
    background-color: white !important;
    border: none;
    padding: 8px 0;
    font-style: normal;
    font-size: 15px;
    line-height: 22px;
    color: #222c43;
    opacity: 1;
    -webkit-opacity: 1;
    -webkit-text-fill-color: #222c43;
    cursor: unset;
  }
}
.skill-level {
  margin-bottom: 8px;
  font-size: 15px;
  line-height: 24px;
  color: #222c43;
}
.level-name {
  display: inline-block;
  width: 60px;
  margin-right: 12px;
  color: #636d86;
}

.skill-attr {
  margin-bottom: 8px;
  @include flex(flex-start);
  font-size: 15px;
  line-height: 20px;
  &-name {
    display: inline-block;
    width: 60px;
    margin-right: 12px;
    text-align: left;
    color: #636d86;
  }
  &-value {
    color: #222c43;
  }
}
.score-box {
  display: flex;
  font-size: 28px;
  justify-content: space-around;
  text-align: center;
  height: 99px;
  align-items: center;
  color: #000;
  background: #f5f6f8;
  border-radius: 4px;
  margin-top: 32px;
  margin-bottom: 8px;
  .cn {
    font-size: 17px;
    color: #8c94aa;
    margin-top: 14px;
  }
  > div {
    flex-grow: 1;
    border-right: 1px solid #e8eaee;
  }
  > div > div:first-child {
    font-weight: 500;
  }
  > div:last-child {
    border-right: 0;
  }
}
@media screen and (max-width: 599px) {
  .desc-container {
    width: 100vw;
    padding: 0 4.2vw;
    margin: 0;
  }
  .skill-image {
    width: 91.7vw;
    height: 50.9vw;
    margin: 0;
  }
}
</style>
